import React, { FC } from 'react';
import './PlanningForm.css';
import {
	FaBuilding,
	FaUser,
	RequiredNote,
	SelectField,
	FaCalendar,
	InputField,
	FaClock,
	TextAreaField,
	FaCalendarAlt,
	FeedbackField,
	DomainFormProps
} from '@/Shared';

/**
 * =====================================================
 * Component: PlanningForm
 * =====================================================
 *
 *
 * Domain-specific form UI for Planning.
 * Mounted inside GenericDomainForm.
 *
 * Responsibilities:
 * - Render activity fields
 * - Use data from formVM (options, values)
 *
 * No permissions, no loading, no orchestration logic here.
 *
 * Author: Samano CASTRE
 * Date: February 15, 2026
 */
const PlanningForm: FC<DomainFormProps> = ({
	domainFormHook,
	formRef,
	formikProps,

}) => {

	const { values, setFieldValue: formikFieldSetter } = formikProps;
	const { entityFormVM } = domainFormHook;

	/**
	 * =====================================================
	 * Main Form Rendering
	 * =====================================================
	 *
	 * Fieldsets organize the form into logical sections for clarity.
	 */
	return (

		<div className="fieldset-wrapper">

			<fieldset>
				<legend>Type & Date</legend>
				<SelectField
					label='Type'
					required
					icon={<FaCalendar />}
					name='type'
					placeholder='"Choisir un type"'
					options={entityFormVM.planningTypeOptions}
					scrollParent={formRef.current}
				/>
				<InputField
					label='Date'
					icon={<FaCalendarAlt />}
					name='planningDate'
					required
					type='date'
				/>
				<InputField
					label='Heure de début'
					icon={<FaClock />}
					name='startTime'
					required
					type='time'
				/>
				<InputField
					label='Heure de fin'
					icon={<FaClock />}
					name='endTime'
					required
					type='time'
				/>

				<RequiredNote />
			</fieldset>
			<fieldset>
				<legend>Agent & Buts</legend>
				<SelectField
					label='Agent'
					required
					icon={<FaUser />}
					name='agentId'
					placeholder='Choisir un agent'
					options={entityFormVM.userOptions}
					scrollParent={formRef.current}
				/>

				<SelectField
					label='Prospect'
					icon={<FaUser />}
					name='contactId'
					placeholder='Choisir un prospect'
					options={entityFormVM.contactOptions}
					scrollParent={formRef.current}
				/>
				<SelectField
					label='Bien'
					icon={<FaBuilding />}
					name='propertyIds'
					placeholder='Choisir un bien'
					options={entityFormVM.propertyOptions}
					scrollParent={formRef.current}
					isMulti
					required
				/>
			</fieldset>
			<fieldset>
				<legend>Appréciation</legend>

				<FeedbackField
					label='Feedback'
					name='feedback'
					value={values.feedback}
					onIconClick={(value: number) => {
						console.log(value);
						formikFieldSetter('feedback', String(value))
					}
					}
				/>
				<TextAreaField
					label='Remarques'
					name='remarks'
				/>
				<TextAreaField
					label='Note'
					name='note'
				/>

			</fieldset>
		</div>

	);
}

export default PlanningForm;
